export function hasWebAccess(user) {
  return user.attributes.type === "Manager";
}

export default {
  hasWebAccess,
};
